import { useRouter } from "next/navigation"
import { useCallback, useTransition } from "react"
import { NavigateType } from "@/src/constants/common"

type NavigateFn = (
  url: string,
  event?: React.MouseEvent<any | HTMLAnchorElement>,
  options?: Record<string, any>,
  type?: NavigateType,
) => void

const useCustomRouter = () => {
  const router = useRouter()
  const [, startTransition] = useTransition()

  const navigate: NavigateFn = useCallback(
    (url, event, options, type = NavigateType.PUSH) => {
      const decodedUrl = decodeURIComponent(url)

      if (!event) {
        startTransition(() => {
          if (type === NavigateType.PUSH) {
            router.push(decodedUrl, options)
          } else {
            router.replace(decodedUrl, options)
          }
        })
        return
      }

      // middle-clicking
      if (event?.button === 1 || event.metaKey || event.ctrlKey) {
        window.open(decodedUrl, "_blank")
      } else {
        startTransition(() => {
          if (type === NavigateType.PUSH) {
            router.push(decodedUrl, options)
          } else {
            router.replace(decodedUrl, options)
          }
        })
      }
    },
    [router, startTransition],
  )

  return { navigate }
}

export default useCustomRouter
